export class DateAndTimeUtils {

  /**
   * Checks if the current date is valid based on the given dates validFrom and validTo.
   * A date is valid if it is:
   * - in between the 2 dates
   * - after validFrom if validTo is not defined
   * - before validTo if validFrom is not defined
   * - if neither validTo and validFrom are defined
   *
   * @param start String or Date representing the start of the valid period
   * @param end String or Date representing the end of the valid period
   */
  static isCurrentDateBetween (start: Date | string | null | undefined, end: Date | string | null | undefined): boolean {
    const currentDate = new Date()
    const startDate = start ? new Date(start) : null
    const endDate = end ? new Date(end) : null
    if (Object.prototype.toString.call(startDate) === '[object Date]' && !isNaN(startDate?.getTime() as number)) {
      if (Object.prototype.toString.call(endDate) === '[object Date]' && !isNaN(endDate?.getTime() as number)) {
        return currentDate > (startDate as Date) && currentDate < (endDate as Date)
      }
      return currentDate > (startDate as Date)
    }
    if (Object.prototype.toString.call(endDate) === '[object Date]' && !isNaN(endDate?.getTime() as number)) {
      return currentDate < (endDate as Date)
    }
    return true
  }
}
